if (typeof customElements.get('product-upsells') === 'undefined') {
  class ProductUpsells extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.productFormId);
      if (!this.form) return;

      this.productForm = this.form.closest('product-form');
      this.submitButton = this.form.querySelector('[data-js-product-add-to-cart]');
      this.submitButtonText = this.form.querySelector('[data-js-product-add-to-cart-text]');
      this.quantityInput = this.form.querySelector('[name="quantity"]');
      this.defaultSubmitLabel = this.submitButtonText ? this.submitButtonText.textContent.trim() : '';
      this.mainVariants = this.readMainVariants();
      this.mainPrice = Number(this.dataset.mainPrice || 0);
      this.items = Array.from(this.querySelectorAll('[data-upsell-item]'));
      this.error = this.querySelector('[data-upsell-error]');

      this.addEventListener('click', this.onUpsellClick.bind(this));
      this.addEventListener('change', this.onUpsellVariantChange.bind(this));
      this.addEventListener('input', this.onPersonalizationInput.bind(this));
      this.form.addEventListener('submit', this.onCombinedSubmit.bind(this), true);

      if (this.quantityInput) {
        this.quantityInput.addEventListener('input', this.updateTotals.bind(this));
        this.quantityInput.addEventListener('change', this.updateTotals.bind(this));
      }
      this.form.addEventListener('click', event => {
        if (event.target.closest('.qty-button')) setTimeout(() => this.updateTotals(), 0);
      });

      const sectionId = this.dataset.productFormId.replace('product-form-', '');
      const variantsElement = document.querySelector(`product-variants[data-id="${CSS.escape(sectionId)}"]`);
      if (variantsElement) {
        variantsElement.addEventListener('VARIANT_CHANGE', () => {
          this.updateMainPrice();
          this.updateTotals();
        });
      }

      this.items.forEach(item => this.renderItem(item));
      this.updateTotals();
    }

    readMainVariants() {
      const json = this.querySelector('[data-main-variants]');
      try {
        return json ? JSON.parse(json.textContent) : [];
      } catch (error) {
        return [];
      }
    }

    onUpsellClick(event) {
      const imageOpen = event.target.closest('[data-upsell-image-open]');
      if (imageOpen) {
        this.openImage(imageOpen.closest('[data-upsell-item]'));
        return;
      }

      const imageClose = event.target.closest('[data-upsell-image-close]');
      if (imageClose) {
        this.closeImage(imageClose.closest('[data-upsell-lightbox]'));
        return;
      }

      const lightbox = event.target.closest('[data-upsell-lightbox]');
      if (lightbox && event.target === lightbox) {
        this.closeImage(lightbox);
        return;
      }

      const button = event.target.closest('[data-upsell-toggle]');
      if (!button) return;

      const item = button.closest('[data-upsell-item]');
      if (item.dataset.hasVariantChoices === 'true') {
        if (this.isSelected(item)) {
          this.deselect(item);
        } else {
          this.openVariants(item);
        }
      } else if (this.isSelected(item)) {
        this.deselect(item);
      } else {
        this.select(item, {
          id: item.dataset.defaultVariantId,
          price: Number(item.dataset.defaultVariantPrice || 0),
          title: ''
        });
      }
    }

    onUpsellVariantChange(event) {
      const input = event.target.closest('[data-upsell-variant]');
      if (!input || !input.checked) return;

      const item = input.closest('[data-upsell-item]');
      this.select(item, {
        id: input.value,
        price: Number(input.dataset.variantPrice || 0),
        title: input.dataset.variantTitle || '',
        image: input.dataset.variantImage || '',
        imageLarge: input.dataset.variantImageLarge || '',
        personalization: input.dataset.upsellPersonalization === 'true'
      });
    }

    onPersonalizationInput(event) {
      const input = event.target.closest('[data-upsell-personalization-input]');
      if (!input) return;
      if (input.value.length > 30) input.value = input.value.slice(0, 30);
      const counter = input.closest('[data-upsell-personalization-panel]').querySelector('[data-upsell-personalization-count]');
      if (counter) counter.textContent = `${input.value.length}/30`;
    }

    select(item, variant) {
      if (item.dataset.upsellGroup === 'gift') {
        this.items
          .filter(other => other !== item && other.dataset.upsellGroup === 'gift')
          .forEach(other => this.deselect(other));
      }

      item.dataset.selectedVariantId = variant.id;
      item.dataset.selectedPrice = variant.price;
      item.dataset.selectedVariantTitle = variant.title;
      item.dataset.selectedPersonalization = variant.personalization ? 'true' : 'false';
      item.classList.add('is-selected');

      if (variant.image) {
        const image = item.querySelector('.product-upsell__image img');
        if (image) image.src = variant.image;
        item.dataset.currentImageLarge = variant.imageLarge || variant.image;
      }

      if (item.dataset.hasVariantChoices === 'true') {
        this.openVariants(item);
      } else {
        this.closeVariants(item);
      }
      this.renderItem(item);
      this.hideError();
      this.updateTotals();
    }

    deselect(item) {
      delete item.dataset.selectedVariantId;
      delete item.dataset.selectedPrice;
      delete item.dataset.selectedVariantTitle;
      delete item.dataset.selectedPersonalization;
      item.classList.remove('is-selected');
      item.querySelectorAll('[data-upsell-variant]').forEach(input => { input.checked = false; });
      const image = item.querySelector('.product-upsell__image img');
      if (image && item.dataset.defaultImage) image.src = item.dataset.defaultImage;
      delete item.dataset.currentImageLarge;
      this.closeVariants(item);
      this.renderItem(item);
      this.updateTotals();
    }

    openVariants(item) {
      if (item.dataset.upsellGroup === 'gift') {
        this.items
          .filter(other => other !== item && other.dataset.upsellGroup === 'gift')
          .forEach(other => this.closeVariants(other));
      }
      const panel = item.querySelector('[data-upsell-variants]');
      const button = item.querySelector('[data-upsell-toggle]');
      if (panel) panel.hidden = false;
      if (button) button.setAttribute('aria-expanded', 'true');
      item.classList.add('is-choosing');
    }

    closeVariants(item) {
      const panel = item.querySelector('[data-upsell-variants]');
      const button = item.querySelector('[data-upsell-toggle]');
      if (panel) panel.hidden = true;
      if (button && button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-choosing');
    }

    renderItem(item) {
      const buttonText = item.querySelector('[data-upsell-button-text]');
      if (!buttonText) return;

      const selected = this.isSelected(item);
      const price = selected
        ? Number(item.dataset.selectedPrice || 0)
        : Number(item.dataset.displayPrice || 0);
      const prefix = !selected && item.dataset.priceVaries === 'true' ? 'vanaf ' : '';
      const label = selected ? this.dataset.selectedLabel : this.dataset.selectLabel;
      buttonText.textContent = `${label} — ${prefix}${this.formatMoney(price)}`;

      const button = item.querySelector('[data-upsell-toggle]');
      if (button) button.setAttribute('aria-pressed', selected ? 'true' : 'false');

      const selection = item.querySelector('[data-upsell-selection]');
      if (selection) {
        selection.textContent = item.dataset.selectedVariantTitle || '';
        selection.hidden = !selected || !selection.textContent;
      }

      const lightboxCaption = item.querySelector('[data-upsell-lightbox-caption]');
      if (lightboxCaption) {
        lightboxCaption.textContent = selected && item.dataset.selectedVariantTitle
          ? `${item.dataset.productTitle} — ${item.dataset.selectedVariantTitle}`
          : item.dataset.productTitle;
      }

      const personalizationPanel = item.querySelector('[data-upsell-personalization-panel]');
      if (personalizationPanel) {
        personalizationPanel.hidden = !selected || item.dataset.selectedPersonalization !== 'true';
      }
    }

    openImage(item) {
      const lightbox = item.querySelector('[data-upsell-lightbox]');
      const image = item.querySelector('[data-upsell-lightbox-image]');
      if (!lightbox || !image) return;
      image.src = item.dataset.currentImageLarge || item.dataset.defaultImageLarge || item.dataset.defaultImage;
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
    }

    closeImage(lightbox) {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
    }

    isSelected(item) {
      return Boolean(item.dataset.selectedVariantId);
    }

    selectedItems() {
      return this.items.filter(item => this.isSelected(item));
    }

    getMainQuantity() {
      return Math.max(1, Number(this.quantityInput ? this.quantityInput.value : 1) || 1);
    }

    updateMainPrice() {
      const variantInput = this.form.querySelector('[name="id"]');
      const variant = this.mainVariants.find(candidate => String(candidate.id) === String(variantInput && variantInput.value));
      if (variant) this.mainPrice = Number(variant.price || 0);
    }

    updateTotals() {
      this.updateMainPrice();
      const selected = this.selectedItems();
      const mainQuantity = this.getMainQuantity();
      const extrasTotal = selected.reduce((total, item) => {
        const quantity = item.dataset.upsellGroup === 'gift' ? mainQuantity : 1;
        return total + (Number(item.dataset.selectedPrice || 0) * quantity);
      }, 0);
      const grandTotal = (this.mainPrice * mainQuantity) + extrasTotal;

      if (this.submitButtonText) {
        if (selected.length) {
          this.submitButtonText.textContent = `${this.dataset.combinedLabel} — ${this.formatMoney(grandTotal)}`;
        } else {
          this.submitButtonText.textContent = this.currentDefaultSubmitLabel();
        }
      }

      if (this.productForm) this.productForm.classList.toggle('has-upsell-selection', selected.length > 0);
    }

    currentDefaultSubmitLabel() {
      if (this.submitButton && this.submitButton.classList.contains('disabled')) {
        return this.submitButtonText ? this.submitButtonText.textContent : this.defaultSubmitLabel;
      }
      if (window.KROWN && KROWN.settings && KROWN.settings.locales) {
        return KROWN.settings.locales.products_add_to_cart_button || this.defaultSubmitLabel;
      }
      return this.defaultSubmitLabel;
    }

    async onCombinedSubmit(event) {
      const selected = this.selectedItems();
      if (!selected.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.hideError();
      if (this.submitButton) this.submitButton.classList.add('working');

      try {
        const items = this.buildCartItems(selected);
        const endpoint = `${KROWN.settings.routes.cart_add_url}.js`;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status === 422) throw new Error(result.description || result.message || 'Toevoegen aan de winkelmand is niet gelukt.');

        this.selectedItems().forEach(item => {
          this.deselect(item);
          const personalizationInput = item.querySelector('[data-upsell-personalization-input]');
          const personalizationCounter = item.querySelector('[data-upsell-personalization-count]');
          if (personalizationInput) personalizationInput.value = '';
          if (personalizationCounter) personalizationCounter.textContent = '0/30';
        });
        this.announceCartUpdate();
        if (this.productForm && this.productForm.hasAttribute('data-ajax-cart') && typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          window.location.href = KROWN.settings.routes.cart_url;
        }
      } catch (error) {
        this.showError(error.message);
      } finally {
        if (this.submitButton) this.submitButton.classList.remove('working');
      }
    }

    buildCartItems(selected) {
      const formData = new FormData(this.form);
      const mainItem = {
        id: String(formData.get('id')),
        quantity: this.getMainQuantity()
      };
      const properties = {};
      for (const [name, value] of formData.entries()) {
        const match = name.match(/^properties\[(.*)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      }
      if (Object.keys(properties).length) mainItem.properties = properties;
      if (formData.get('selling_plan')) mainItem.selling_plan = String(formData.get('selling_plan'));

      const lines = new Map();
      selected.forEach(item => {
        const id = String(item.dataset.selectedVariantId);
        const quantity = item.dataset.upsellGroup === 'gift' ? this.getMainQuantity() : 1;
        const line = lines.get(id) || { id, quantity: 0 };
        line.quantity += quantity;

        if (item.dataset.selectedPersonalization === 'true') {
          const personalizationInput = item.querySelector('[data-upsell-personalization-input]');
          const personalizationText = personalizationInput ? personalizationInput.value.trim() : '';
          if (personalizationText) {
            line.properties = {
              ...(line.properties || {}),
              'Bedrukking jute zak': personalizationText
            };
          }
        }

        lines.set(id, line);
      });

      return [mainItem, ...Array.from(lines.values())];
    }

    formatMoney(cents) {
      const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'EUR';
      const locale = document.documentElement.lang || 'nl-NL';
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = false;
    }

    hideError() {
      if (this.error) this.error.hidden = true;
    }

    announceCartUpdate() {
      const announcer = document.getElementById('screen-reader-info');
      if (!announcer) return;
      announcer.innerText = KROWN.settings.locales.cart_announcement || 'Toegevoegd aan de winkelmand';
      setTimeout(() => { announcer.innerText = ''; }, 1000);
    }
  }

  customElements.define('product-upsells', ProductUpsells);
}
